/*
 * AJ Vídeo Carrossel 2
 * ---------------------
 * Prévias mudas na grade + visualizador em tela cheia com áudio destravado
 * e barra de compra. Fica aqui (e não inline na seção) porque o editor de
 * temas re-renderiza seções com innerHTML e <script> inserido assim nunca
 * executa. Re-inicializa em shopify:section:load.
 */
(function () {
  'use strict';

  var VIEW = null;
  var state = {
    items: [],
    index: 0,
    muted: false,
    product: null,
    selection: [],
  };

  var addUrl = function () {
    return (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
  };

  function lockScroll(on) {
    if (on) {
      var gap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = gap > 0 ? gap + 'px' : '';
      document.body.style.overflow = 'hidden';
      return;
    }
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  /* ------------------------------------------------------------ prévias */
  /* Apenas o primeiro cartão traz <video>; os demais ficam no poster parado. */

  var previewObserver = null;

  // Chamar play() no mesmo tick em que o src é definido falha ("interrupted by a
  // new load request"), então insistimos quando a mídia estiver pronta.
  function playPreview(video) {
    var attempt = video.play();
    if (!attempt || !attempt.catch) return;

    attempt.catch(function () {
      var retry = function () {
        var again = video.play();
        if (again && again.catch) again.catch(function () {});
      };
      video.addEventListener('loadeddata', retry, {once: true});
      video.addEventListener('canplay', retry, {once: true});
    });
  }

  function getPreviewObserver() {
    if (previewObserver || !('IntersectionObserver' in window)) return previewObserver;

    previewObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var video = card.querySelector('[data-ajvc-previa]');
          if (!video) return;

          if (!entry.isIntersecting) {
            video.pause();
            return;
          }

          if (!video.getAttribute('src')) {
            video.setAttribute('src', card.getAttribute('data-src'));
            video.load();
          }

          playPreview(video);
        });
      },
      {rootMargin: '80px'}
    );

    return previewObserver;
  }

  function initPreviews(scope) {
    var saveData = navigator.connection && navigator.connection.saveData;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (saveData || reduced) return;

    var observer = getPreviewObserver();
    if (!observer) return;

    scope.querySelectorAll('[data-ajvc-card]').forEach(function (card) {
      if (card.ajvcObserved) return;
      card.ajvcObserved = true;

      var video = card.querySelector('[data-ajvc-previa]');
      if (video) {
        video.addEventListener('playing', function () {
          card.classList.add('is-playing');
        });
        video.addEventListener('pause', function () {
          card.classList.remove('is-playing');
        });
      }

      observer.observe(card);
    });
  }

  /* ---------------------------------------------------------- carrossel */

  function initCarousel(section) {
    if (section.ajvcCarouselReady) return;

    var list = section.querySelector('[data-ajvc-list]');
    var prev = section.querySelector('[data-ajvc-prev]');
    var next = section.querySelector('[data-ajvc-next]');
    if (!list || !prev || !next) return;

    section.ajvcCarouselReady = true;

    function step() {
      var card = list.querySelector('[data-ajvc-card]');
      return card ? card.offsetWidth + 10 : list.clientWidth;
    }

    function sync() {
      var max = list.scrollWidth - list.clientWidth - 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      list.scrollBy({left: -step(), behavior: 'smooth'});
    });
    next.addEventListener('click', function () {
      list.scrollBy({left: step(), behavior: 'smooth'});
    });
    list.addEventListener('scroll', sync, {passive: true});
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);

    // No primeiro sync a lista ainda pode não ter largura, e aí o trilho parece
    // não rolar e as duas setas nascem desabilitadas.
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(sync);
      ro.observe(list);
      var first = list.querySelector('[data-ajvc-card]');
      if (first) ro.observe(first);
    }

    sync();
  }

  /* ------------------------------------------------------- visualizador */

  function buildView() {
    if (VIEW) return VIEW;

    var view = document.createElement('div');
    view.className = 'ajvc__view';
    view.setAttribute('role', 'dialog');
    view.setAttribute('aria-modal', 'true');
    view.hidden = true;
    view.innerHTML = [
      '<div class="ajvc__stage" data-ajvc-stage>',
      '  <video class="ajvc__video" playsinline webkit-playsinline preload="auto" data-ajvc-video></video>',
      '  <div class="ajvc__bars" data-ajvc-bars></div>',
      '  <div class="ajvc__tools">',
      '    <button type="button" class="ajvc__tool ajvc__tool--audio" data-ajvc-audio aria-label="Ativar ou desativar o som">',
      '      <svg class="ajvc-icon-on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>',
      '      <svg class="ajvc-icon-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M22 9l-6 6"/><path d="M16 9l6 6"/></svg>',
      '    </button>',
      '    <button type="button" class="ajvc__tool ajvc__tool--x" data-ajvc-close aria-label="Fechar">&times;</button>',
      '  </div>',
      '  <button type="button" class="ajvc__zone ajvc__zone--l" data-ajvc-prev-video aria-label="Anterior"></button>',
      '  <button type="button" class="ajvc__zone ajvc__zone--r" data-ajvc-next-video aria-label="Próximo"></button>',
      '  <form class="ajvc__form" method="post" enctype="multipart/form-data" novalidate data-product-form data-ajvc-form>',
      '    <input type="hidden" name="form_type" value="product">',
      '    <input type="hidden" name="utf8" value="✓">',
      '    <input type="hidden" name="id" value="" data-ajvc-vid>',
      '    <input type="hidden" name="quantity" value="1">',
      '    <div class="ajvc__errors ajvc__errors--float" data-cart-errors-container></div>',
      '    <div class="ajvc__opts" hidden data-ajvc-opts></div>',
      '    <div class="ajvc__buy" data-ajvc-buy></div>',
      '  </form>',
      '</div>',
    ].join('');

    document.body.appendChild(view);
    VIEW = view;
    bindView(view);
    return view;
  }

  function bindView(view) {
    var video = view.querySelector('[data-ajvc-video]');

    view.addEventListener('click', function (event) {
      if (event.target === view) closeView();
    });

    view.querySelector('[data-ajvc-close]').addEventListener('click', closeView);
    view.querySelector('[data-ajvc-prev-video]').addEventListener('click', function () {
      go(state.index - 1);
    });
    view.querySelector('[data-ajvc-next-video]').addEventListener('click', function () {
      go(state.index + 1);
    });

    view.querySelector('[data-ajvc-audio]').addEventListener('click', function () {
      state.muted = !state.muted;
      video.muted = state.muted;
      if (!state.muted) video.volume = 1;
      view.classList.toggle('is-muted', state.muted);
    });

    video.addEventListener('timeupdate', function () {
      var bar = view.querySelectorAll('[data-ajvc-bars] i b')[state.index];
      if (!bar || !video.duration) return;
      bar.style.width = (video.currentTime / video.duration) * 100 + '%';
    });

    video.addEventListener('ended', function () {
      if (state.index < state.items.length - 1) go(state.index + 1);
    });

    document.addEventListener('keydown', function (event) {
      if (view.hidden) return;
      if (event.key === 'Escape') closeView();
      if (event.key === 'ArrowRight') go(state.index + 1);
      if (event.key === 'ArrowLeft') go(state.index - 1);
    });
  }

  /* ------------------------------------------------------------- compra */

  function money(variant) {
    if (!variant) return '';
    if (!variant.compareAt) return variant.price;
    return variant.price + '<s>' + variant.compareAt + '</s>';
  }

  function currentVariant() {
    var product = state.product;
    if (!product) return null;
    if (product.single) return product.variants[0];

    return (
      product.variants.filter(function (variant) {
        return variant.options.every(function (value, i) {
          return state.selection[i] === value;
        });
      })[0] || null
    );
  }

  function valueAvailable(optionIndex, value) {
    return state.product.variants.some(function (variant) {
      if (!variant.available) return false;
      if (variant.options[optionIndex] !== value) return false;
      return variant.options.every(function (other, i) {
        return i === optionIndex || !state.selection[i] || state.selection[i] === other;
      });
    });
  }

  function renderBuy() {
    var view = VIEW;
    var product = state.product;
    var buy = view.querySelector('[data-ajvc-buy]');
    var opts = view.querySelector('[data-ajvc-opts]');
    var vid = view.querySelector('[data-ajvc-vid]');
    var variant = currentVariant();

    view.querySelector('[data-cart-errors-container]').innerHTML = '';

    var info =
      '<div class="ajvc__buy-info">' +
      '<span class="ajvc__buy-title">' +
      product.title +
      '</span>' +
      '<span class="ajvc__buy-price">' +
      money(variant || product.variants[0]) +
      '</span>' +
      '</div>';

    if (product.single) {
      vid.value = product.variants[0].id;
      buy.innerHTML =
        info +
        '<button type="submit" class="ajvc__buy-btn" data-add-to-cart' +
        (product.variants[0].available ? '' : ' disabled') +
        '>' +
        (product.variants[0].available ? 'Adicionar' : 'Esgotado') +
        '</button>';
      opts.hidden = true;
      return;
    }

    vid.value = variant && variant.available ? variant.id : '';
    buy.innerHTML = info + '<button type="button" class="ajvc__buy-btn" data-ajvc-cta>Adicionar</button>';

    var groups = product.optionNames
      .map(function (name, i) {
        var seen = [];
        var values = product.variants
          .map(function (variant) {
            return variant.options[i];
          })
          .filter(function (value) {
            if (seen.indexOf(value) > -1) return false;
            seen.push(value);
            return true;
          });

        return (
          '<div class="ajvc__opt">' +
          '<span class="ajvc__opt-name">' +
          name +
          '</span>' +
          '<div class="ajvc__opt-values">' +
          values
            .map(function (value) {
              return (
                '<button type="button" class="ajvc__val" data-ajvc-val data-opt="' +
                i +
                '" data-value="' +
                String(value).replace(/"/g, '&quot;') +
                '" aria-pressed="' +
                (state.selection[i] === value) +
                '" data-unavailable="' +
                !valueAvailable(i, value) +
                '">' +
                value +
                '</button>'
              );
            })
            .join('') +
          '</div>' +
          '</div>'
        );
      })
      .join('');

    var ready = !!(variant && variant.available);

    opts.innerHTML =
      groups +
      '<div class="ajvc__opts-foot">' +
      info +
      '<button type="submit" class="ajvc__buy-btn" data-add-to-cart' +
      (ready ? '' : ' disabled') +
      '>' +
      (variant && !variant.available ? 'Esgotado' : 'Adicionar') +
      '</button>' +
      '</div>';
  }

  function initSelection() {
    var product = state.product;
    if (product.single) {
      state.selection = [];
      return;
    }

    var first =
      product.variants.filter(function (variant) {
        return variant.available;
      })[0] || product.variants[0];

    state.selection = first ? first.options.slice() : [];
  }

  /* --------------------------------------------------------- abrir/fechar */

  function go(index) {
    if (index < 0 || index >= state.items.length) return;

    state.index = index;

    var view = VIEW;
    var video = view.querySelector('[data-ajvc-video]');
    var bars = view.querySelectorAll('[data-ajvc-bars] i b');

    bars.forEach(function (bar, i) {
      bar.style.width = i < index ? '100%' : '0%';
    });

    video.src = state.items[index];
    video.muted = state.muted;
    video.currentTime = 0;

    var attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(function () {
        // Sem gesto suficiente para tocar com som: cai para mudo.
        state.muted = true;
        video.muted = true;
        view.classList.add('is-muted');
        var retry = video.play();
        if (retry && retry.catch) retry.catch(function () {});
      });
    }
  }

  function openView(section, index) {
    var view = buildView();
    var data = section.querySelector('[data-ajvc-product]');

    state.items = Array.prototype.map.call(section.querySelectorAll('[data-ajvc-card]'), function (card) {
      return card.getAttribute('data-src');
    });

    try {
      state.product = JSON.parse(data.textContent);
    } catch (error) {
      state.product = null;
    }
    if (!state.product) return;

    // O áudio fica destravado ao abrir; o botão ao lado do X inverte isso.
    state.muted = false;
    view.classList.remove('is-muted', 'is-picking');

    view.querySelector('[data-ajvc-form]').setAttribute('action', addUrl());
    view.querySelector('[data-ajvc-bars]').innerHTML = state.items
      .map(function () {
        return '<i><b></b></i>';
      })
      .join('');

    initSelection();
    renderBuy();

    view.querySelector('[data-ajvc-opts]').hidden = true;

    view.hidden = false;
    lockScroll(true);

    go(index);
  }

  function closeView() {
    if (!VIEW || VIEW.hidden) return;

    var video = VIEW.querySelector('[data-ajvc-video]');
    video.pause();
    video.removeAttribute('src');
    video.load();

    VIEW.hidden = true;
    VIEW.classList.remove('is-picking');
    lockScroll(false);
  }

  /* -------------------------------------------------------------- eventos */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var card = target.closest('[data-ajvc-card]');
    if (card) {
      var section = card.closest('[data-ajvc]');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-ajvc-card]'));
      openView(section, cards.indexOf(card));
      return;
    }

    if (!VIEW || VIEW.hidden) return;

    if (target.closest('[data-ajvc-cta]')) {
      VIEW.classList.add('is-picking');
      VIEW.querySelector('[data-ajvc-opts]').hidden = false;
      return;
    }

    var value = target.closest('[data-ajvc-val]');
    if (value) {
      state.selection[Number(value.getAttribute('data-opt'))] = value.getAttribute('data-value');
      renderBuy();
      VIEW.querySelector('[data-ajvc-opts]').hidden = false;
    }
  });

  // O carrinho do tema cuida do POST; aqui só fechamos o visualizador.
  document.addEventListener('theme:cart:added', closeView);

  function init() {
    document.querySelectorAll('[data-ajvc]').forEach(function (section) {
      initPreviews(section);
      if (section.classList.contains('ajvc--carousel')) initCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
